import {omit} from 'helpers';
import {AnyObject} from 'types';

export class ApiError extends Error {
  name = 'ApiError';
  error: Error;
  request: AnyObject;
  url: string;

  constructor({error, payload, url}: {error: Error, payload: AnyObject, url: string}) {
    super(`${error}. ${url}`);
    this.error = error;
    this.request = omit(payload, ['app', 'version', 'deviceId', 'token', 'password', 'password2']);
    this.url = url;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, Error);
    } else {
      this.stack = (new Error()).stack;
    }
  }
}

export class NetworkError extends Error {
  name = 'NetworkError';
  error = 'Failed to fetch';
  disconnected = true;
  url: string;

  constructor(url: string) {
    super(`Failed to fetch: ${url}`);
    this.url = url;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, Error);
    } else {
      this.stack = (new Error()).stack;
    }
  }
}
